(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/teams/assets/javascripts/services/type-mapping.js') >= 0) return;  svs.modules.push('/components/marketplace-data/teams/assets/javascripts/services/type-mapping.js'); 
'use strict';

const types = {
  PRIVATE: 'PRIVATE',
  RETAILER: 'RETAILER'
};
const mapper = {
  1: types.PRIVATE,
  3: types.RETAILER
};
setGlobal('svs.components.marketplaceData.teams.services.typeMapping', {
  mapper,
  types
});
 })(window);